import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const AssetIcon = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 20 20"
      data-fill-none
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.20002 2.10039C2.86739 2.10039 2.60002 2.36776 2.60002 2.70039V18.3003C2.60002 18.633 2.86743 18.9004 3.20002 18.9004H16.6772C17.0098 18.9004 17.2772 18.633 17.2772 18.3003V5.00438C17.2772 4.84242 17.212 4.68802 17.101 4.58052C17.1008 4.58035 17.1012 4.5807 17.101 4.58052L14.6928 2.2687C14.5859 2.16177 14.4365 2.10039 14.2772 2.10039H3.20002ZM1.40002 2.70039C1.40002 1.70502 2.20465 0.900391 3.20002 0.900391H14.2772C14.7396 0.900391 15.1962 1.07742 15.5367 1.41537L17.934 3.71676C18.2866 4.05725 18.4772 4.52661 18.4772 5.00438V18.3003C18.4772 19.2957 17.6726 20.1004 16.6772 20.1004H3.20002C2.20461 20.1004 1.40002 19.2957 1.40002 18.3003V2.70039Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.0282 6.02969C5.0282 5.69832 5.29683 5.42969 5.6282 5.42969H11.7398C12.0712 5.42969 12.3398 5.69832 12.3398 6.02969C12.3398 6.36106 12.0712 6.62969 11.7398 6.62969H5.6282C5.29683 6.62969 5.0282 6.36106 5.0282 6.02969Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.0282 9.26797C5.0282 8.9366 5.29683 8.66797 5.6282 8.66797H13.5439C13.8753 8.66797 14.1439 8.9366 14.1439 9.26797C14.1439 9.59934 13.8753 9.86797 13.5439 9.86797H5.6282C5.29683 9.86797 5.0282 9.59934 5.0282 9.26797Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.0282 12.6566C5.0282 12.3253 5.29683 12.0566 5.6282 12.0566H13.5439C13.8753 12.0566 14.1439 12.3253 14.1439 12.6566C14.1439 12.988 13.8753 13.2566 13.5439 13.2566H5.6282C5.29683 13.2566 5.0282 12.988 5.0282 12.6566Z"
        fill="currentColor"
      />
    </SvgIcon>
  ))
);
